<template>
    <v-dialog v-bind="$attrs" persistent content-class="modal-dialog">
        <div class="modal-message">
            <div class="common-text mb-2" v-if="title">
                {{title}}
            </div>
            <div class="main-text mb-5" :class="{'text-center': textCenter}" v-if="text" v-html="text"></div>
            <v-flex class="d-flex w-100 justify-center mt-3" v-if="!noCancel">
                <v-btn class="btn-dark main-text" @click="close">
                    {{textBtn}}
                </v-btn>
                <v-btn v-if="showConfirmBtn" class="yellow-btn small-btn main-text" @click="$emit('confirm')">
                    {{textConfirmBtn}}
                </v-btn>
            </v-flex>
        </div>
    </v-dialog>
</template>

<script>
export default {
    name: "ModalMessage",
    props: {
        title: {
            type: String,
            default: null,
        },
        text: {
            type: String,
            default: null,
        },
        textBtn: {
            type: String,
            default: "Отмена",
        },
        noCancel: {
            type: Boolean,
            default: false,
        },
        noLoading: {
            type: Boolean,
            default: false,
        },
        textCenter: {
            type: Boolean,
            default: false,
        },
        showConfirmBtn: {
            type: Boolean,
            default: false,
        },
        textConfirmBtn: {
            type: String,
            default: "Ок",
        },
    },
    methods: {
        close() {
            this.$emit('input', false);
        },
    }
}
</script>

<style lang="scss" scoped>
.modal-message {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
}

.btn-dark.v-btn {
    max-width: 107px;
}

.yellow-btn.small-btn.v-btn {
    width: auto;
    min-width: 105px;
    max-height: 42px;
    min-height: 42px;
    margin-left: 8px;
}
</style>